<template src="./articoliFornitori.html"></template>

<script>
import {
  get_articoliFornitori,
  save_qtaArticoliFornitori,
} from "@/api/api.fornitori.js";
import MagazForn from "@/components/dialog/MagazFornitore";

export default {
  components: {
    MagazForn,
  },
  data() {
    return {
      dati: [],

      headers: [
        { text: "Cod.Articolo", align: "center", value: "COD_ART_VIS" },
        { text: "Descrizione", align: "left", value: "DESC_ART" },
        { text: "Scorta Minima", align: "left", value: "SOT_SC" },
        { text: "Q.tà", align: "center", value: "QTA_MAG_FOR" },
      ],

      search: "",
      pagination: {
        rowsPerPage: 250,
      },

      dialog: false,

      editedIndex: -1,

      editedItem: {
        COD_ART_VIS: "",
        COD_ART: "",
        COD_ART_MAG_FOR: "",
        DESC_ART: "",
        QTA_MAG_FOR: 0,
        QTA_PREVISIONE: 0,
      },

      filtroSel: "Tutti",
      filtriRicerca: [
        "Tutti",
        "Minimo Scorta",
        "Telai",
        "Coprifili",
        "Giacenze",
      ],
    };
  },

  methods: {
    async caricaDati() {
      // Reset
      this.dati = [];

      // NOTA: la scritta Q.tà manda in errore in errore il controller (non lo trova)
      // let s = this.filtroSel.replace("Q.tà", "Qta");

      try {
        let res = await get_articoliFornitori(this.filtroSel);

        this.dati = res.data;
      } catch (error) {
        console.log(error);
      }
    },

    editItem(item) {
      this.editedIndex = this.dati.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      // Controllo presenza qta
      if (this.editedItem.QTA_MAG_FOR.length == 0) {
        this.editedItem.QTA_MAG_FOR = 0;
        return;
      }
      if (this.editedItem.QTA_PREVISIONE.length == 0) {
        this.editedItem.QTA_PREVISIONE = 0;
        return;
      }
      // -------

      if (this.editedIndex > -1) {
        Object.assign(this.dati[this.editedIndex], this.editedItem);
      } else {
        this.dati.push(this.editedItem);
      }

      // Controllo se è stato modificato il codice, per aggiornare il dato in griglia
      if (this.editedItem.COD_ART_MAG_FOR.length > 0)
        this.dati[this.editedIndex].COD_ART_VIS =
          this.editedItem.COD_ART_MAG_FOR;
      else this.dati[this.editedIndex].COD_ART_VIS = this.editedItem.COD_ART;

      try {
        // Salvo su db
        await save_qtaArticoliFornitori(this.editedItem);
      } catch (error) {
        console.log(error);
      }

      this.close();
    },
  },

  async mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);

    this.caricaDati();
  },
};
</script>

